<ng-container *transloco="let t; read: 'calendarMonths'">
  <div class="container">
    <div *ngFor="let datepickerPeriod of datepickerPeriods">
      <div class="year" [attr.data-qa]="testIdPrefix + '-year-' + datepickerPeriod.year">{{ datepickerPeriod.year }}</div>
      <div class="months ">
        <rx-applications-pill
          class="mr-3 mt-2"
          *ngFor="let datepickerMonth of datepickerPeriod.months"
          [label]="t(datepickerMonth.month)"
          [id]="datepickerMonth.id"
          [selected]="datepickerMonth.selected"
          [range]="datepickerMonth.inRange"
          [allowUnselect]="false"
          [testIdPrefix]="testIdPrefix + '-month'"
          (click)="onMonthClick(datepickerMonth)"
          (mouseover)="onMouseHover(datepickerMonth)"
          (mouseout)="onMouseOut()"
        />
      </div>
    </div>
  </div>
</ng-container>